import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../baseContainers/BaseListContainer';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import { t } from 'i18next';
import ActionLink from '../components/ActionLink';
import CriteriaCalendarRangeComponent from '../components/criteria/CriteriaCalendarRangeComponent';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Column } from 'primereact/column';
import NumberUtils from '../utils/NumberUtils';
import PayReportService from '../services/PayReportService';
import { DataTable } from 'primereact/datatable';
import { Ripple } from 'primereact/ripple';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'react-bootstrap';
import DivContainer from '../components/DivContainer';
import { PrintButtonComponent } from '../report/ReportUtils';


class PayReportListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new PayReportService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            dialogVisibile: false,
        };
    }

    updateSearchCriteria(criteria) {
        return {
            fullName: criteria.fullName,
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            exportType: criteria.exportType,
        };
    }

    getCleanSearchCriteria() {
        return {
            fullName: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'month_',
            sortAsc: false,
            exportType: null,
        };
    }

    getListTitle() {
        return 'payReport.listName';
    }
    
    footerGroup() {
        const { summary } = this.state;
        const formatter = new Intl.NumberFormat('pl-PL', {
            style: 'currency',
            currency: 'PLN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        const formattedNumber = formatter.format(summary.sumOfAmount);

        return (
            <ColumnGroup>
                <Row>
                    <Column footer={t('list.summary')} />
                    <Column footer={null} footerStyle={{ textAlign: 'right', paddingRight: '0px' }} />
                    <Column footer={this.formatTimeIfPossible(summary.sumOfWorkTime)} footerStyle={{ textAlign: 'right', paddingRight: '16px' }} />
                    <Column footer={null} footerStyle={{ textAlign: 'right', paddingRight: '0px' }} />
                    <Column footer={this.formatTimeIfPossible(summary.sumOfEmpDriveTime)} footerStyle={{ textAlign: 'right', paddingRight: '16px' }} />
                    <Column footer={null} footerStyle={{ textAlign: 'right', paddingRight: '0px' }} />
                    <Column footer={this.formatTimeIfPossible(summary.sumLeadDriveTime)} footerStyle={{ textAlign: 'right', paddingRight: '16px' }} />
                    <Column footer={null} footerStyle={{ textAlign: 'right', paddingRight: '0px' }} />
                    <Column footer={this.formatTimeIfPossible(summary.sumExtraDriveTime)} footerStyle={{ textAlign: 'right', paddingRight: '16px' }} />
                    <Column footer={null} footerStyle={{ textAlign: 'right', paddingRight: '0px' }} />
                    <Column footer={formattedNumber} footerStyle={{ textAlign: 'right', paddingRight: '10px' }} />
                </Row>
            </ColumnGroup>
        );
    }

    renderCriteria() {
        return (
            <div className='row'>

                <CriteriaTextComponent
                    id='fullName-sc'
                    name='fullName'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.fullName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('payReport.user')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />

                <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    name='date'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    label={'Data'}
                    colClass='col-xl-6 col-lg-12 col-sm-12'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    sharedLabel
                    renderDash
                    dateFormat="mm/yy"
                    maxDateInfinite
                    placeholderFrom={'Data od'}
                    placeholderTo={'Data do'}
                    inputsClassName='col-6'
                    view="month"
                />
               <CriteriaTextComponent
                    id='subcontractor-sc'
                    name='subcontractor'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.subcontractor}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('payReport.subcontractor')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />

            </div>
        );
    }
    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }

    actionTemplate(rowData) {
        return (
            <span>
                <ActionLink
                    iconName='mdi-pencil'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => this.handleOpenEditDialog(e, rowData)}
                    variant='blue'
                    className='edit-blue-link'
                    key={'view-button'}
                    rendered={false}
                />
            </span>
        );
    }

    handleOpenEditDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ dialogVisibile: true, element: this.cloneElement(rowData), dialogViewMode: 'EDIT' });
    }

    handleOpenDeleteDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ deleteConfirmDialogVisible: true, element: rowData, dialogViewMode: 'DELETE' });
    }

    formatTime(field, rowData) {
        const time = rowData[field];
        return this.formatTimeIfPossible(time);
    }
    formatTimeIfPossible(time) {
        if (NumberUtils.isNumber(time)) {
            const hours = Math.floor(time / 60);
            const mins = time % 60;
            return `${hours}:${mins.toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }
    formatValue(field, rowData) {
        // var currencyField = '';
        // switch (field) {
        //     case 'leadDriveRateVal':
        //         currencyField = 'leadDriveRateCurr'
        //         break;
        //     case 'empDriveRateVal':
        //         currencyField = 'empDriveRateCurr'
        //         break;
        //     case 'amount':
        //         currencyField = 'contractCurrency'
        //         break;
        //     case 'contractRate':
        //         currencyField = 'contractCurrency'
        // }
        if(rowData[field]==null){
            return '';
        }
        const formatter = new Intl.NumberFormat('pl-PL', {
            style: 'currency',
            currency: 'PLN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        const formattedNumber = formatter.format(rowData[field]);
        return formattedNumber;
    }

    prepareColumns() {
        return [{
            field: 'month',
            header: 'Miesiąc',
            sortable: true,
            sortField: 'month_',
        },
        {
            field: 'userFullName',
            header: t('payReport.user'),
            sortable: true,
            sortField: 'lastname',
        },
        {
            field: 'workTime',
            header: t('payReport.worktime'),
            sortable: true,
            body: this.formatTime.bind(this, 'workTime'),
            sortField: 'emp_time',
            sortable: true,
            bodyStyle:{
                textAlign: 'right'
            },
            width: '80px',
        },
        {
            field: 'contractRate',
            header: t('payReport.rate'),
            sortField: 'contract_rate',
            sortable: true,
            body: this.formatValue.bind(this, 'contractRate'),
            bodyStyle:{
                textAlign: 'right'
            },
            width: '80px',            
        },
        {
            field: 'empDriveTime',
            header: t('payReport.employeeDriveTime'),
            sortable: false,
            body: this.formatTime.bind(this, 'empDriveTime'),
            sortField: 'emp_drive_time',
            sortable: true,
            bodyStyle:{
                textAlign: 'right'
            },
            align: 'right'
        },
        {
            field: 'empDriveRateVal',
            header: t('payReport.employeeDriveTimeRate'),
            sortable: false,
            width: '80px',
            sortField: 'emp_drive_rate_val',
            sortable: true,
            body: this.formatValue.bind(this, 'empDriveRateVal'),       
            bodyStyle:{
                textAlign: 'right'
            },
            align: 'right'            
        },
        {
            field: 'leadDriveTime',
            header: t('payReport.leadDriveTime'),
            sortable: false,
            body: this.formatTime.bind(this, 'leadDriveTime'),
            sortField: 'lead_drive_time',
            sortable: true,
            bodyStyle:{
                textAlign: 'right'
            },
            align: 'right'
        },
        {
            field: 'leadDriveRateVal',
            header: t('payReport.leadDriveTimeRate'),
            sortField: 'lead_drive_rate_val',
            body: this.formatValue.bind(this, 'leadDriveRateVal'),
            sortable: true,
            bodyStyle:{
                textAlign: 'right'
            },
            align: 'right'
        },
        {
            field: 'extraDriveTime',
            header: t('payReport.extraDriveTime'),
            sortable: false,
            body: this.formatTime.bind(this, 'extraDriveTime'),
            sortField: 'driving_time',
            sortable: true,
            bodyStyle:{
                textAlign: 'right'
            },
            align: 'right'
        },
        {
            field: 'extraDriveRateVal',
            header: t('payReport.extraDriveRateVal'),
            sortField: 'extra_drive_rate_val',
            body: this.formatValue.bind(this, 'extraDriveRateVal'),
            sortable: true,
            bodyStyle:{
                textAlign: 'right'
            },
            width: '80px'
        },
        {
            field: 'amount',
            header: t('payReport.amount'),
            sortable: false,
            body: this.formatValue.bind(this, 'amount'),
            bodyStyle:{
                textAlign: 'right'
            },
        },
        ];
    }
    prepareHeaderItems() {
        return [

            {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                disabled: !this.state.list || this.state.list.length < 1,
                customRenderFunction: this.renderPrintButton,
            },
        ];
    }

    renderPrintButton() {
        return (
            <PrintButtonComponent
                key={`print-button-pay-report`}
                reportFileNameBase={t('payReport.listName')}
                xml={false}
                pdf={false}
                csv={false}
                ods={false}
                xlsx={false}
                globalFormat='xlsx'
                noMenuFlag={true}
                generateReport={this.generateReport.bind(this)}
                disabled={!this.state.list.length > 0}
            />
        );
    }

    generateReport(format) {
        const { summary } = this.state;
        const criteria = this.state.criteria;
        const listSize = this.state.size;
        //const documentLimit = this.state.documentLimit;
        // if (listSize > documentLimit) {
        //     //return this.showErrorAboutLimitExceeded(documentLimit, listSize);
        // }
        switch (format) {
            case 'xlsx':
                return this.service.exportList(criteria, 'xlsx',summary);
            default:
                return Promise.reject('Nieznany format');
        }
    }

    handleOpenNewDialog(e) {
        let basicElement = this.initNewElement();
        if (e) {
            e.preventDefault();
        }
        this.setState({ dialogVisibile: true, element: basicElement, dialogViewMode: 'NEW' });
    }

    handleDelete(e) {
        if (e) {
            e.preventDefault();
        }
        console.log('delete {}', this.state.element);
        this.service
            .remove(this.state.element)
            .then((response) => {
                this.blockUi();
                this.persistMessage('success', '', t('hourlyreport.deleteSuccess'));
            })
            .catch((err) => {
                this.persistMessage('error', '', t('hourlyreport.deleteError'));
            })
            .finally(() => {
                this.afterObjectUpdate();
                this.setState({ deleteConfirmDialogVisible: false });
            });
    }

    afterObjectUpdate() {
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }

    render() {
        return (
            <div className='container-fluid projectcategory-list'>
                <BreadcrumbsItem to='/pay-report-list'>{'Raport wypłat'}</BreadcrumbsItem>
                {this.renderView()}
            </div>
        );
    }
}

PayReportListContainer.defaultProps = {
    detailUrl: '/#/hourly-report/details',
    newUrl: '/#/hourly-report/create',
    lazy: true,
};

PayReportListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default PayReportListContainer;
